module.exports = __webpack_public_path__ + "img/industriale_pressed.d683935e.png";